<template>
  <div class="flex items-center gap-1.5 px-2 py-1.5 border-b border-slate-600 flex-shrink-0 flex-wrap">
    <input
      type="text"
      :value="search"
      @input="$emit('update:search', $event.target.value)"
      placeholder="Search…"
      class="flex-1 min-w-[90px] text-xs bg-slate-700 text-white border border-slate-500 rounded px-2 py-1 focus:outline-none focus:border-cyan-500"
    />
    <select
      :value="sortKey"
      @change="$emit('update:sortKey', $event.target.value)"
      class="text-xs bg-slate-700 text-white border border-slate-500 rounded px-1.5 py-1 focus:outline-none focus:border-cyan-500 appearance-none"
      title="Sort by"
    >
      <option v-for="opt in sortOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
    </select>
    <select
      v-if="filterOptions && filterOptions.length > 0"
      :value="filterValue"
      @change="$emit('update:filterValue', $event.target.value)"
      class="text-xs bg-slate-700 text-white border border-slate-500 rounded px-1.5 py-1 focus:outline-none focus:border-cyan-500 appearance-none"
      :title="filterLabel"
    >
      <option value="">{{ filterLabel ?? 'All' }}</option>
      <option v-for="opt in filterOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
    </select>
  </div>
</template>

<script setup>
// Generic search/sort/filter chrome — resource-agnostic. It owns no filtering
// logic itself; the consumer applies `search`/`sortKey`/`filterValue` to its
// own list in a computed(), since "what fields to match" is inherently
// specific to the resource type being listed.
defineProps({
  search: { type: String, default: '' },
  sortKey: { type: String, default: '' },
  sortOptions: { type: Array, default: () => [] },   // [{ value, label }]
  filterValue: { type: String, default: '' },
  filterOptions: { type: Array, default: () => [] }, // [{ value, label }]
  filterLabel: { type: String, default: 'All' },
})

defineEmits(['update:search', 'update:sortKey', 'update:filterValue'])
</script>
